import { type CSSProperties, type ReactNode } from "react";
import { Drawer } from "vaul";
import "../../../app/Vaul.css";

export { Drawer };

const defaultContentClass = "vaul-content vaul-content--fit";
const defaultContentStyle: CSSProperties = {
  height: "fit-content",
  overflowY: "auto",
};

export type VaulDrawerShellProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
  contentClassName?: string;
  contentStyle?: CSSProperties;
};

export function VaulDrawerShell({
  open,
  onOpenChange,
  children,
  contentClassName,
  contentStyle,
}: VaulDrawerShellProps) {
  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange}>
      <Drawer.Portal>
        <Drawer.Overlay className="vaul-overlay" />
        <Drawer.Content
          className={
            contentClassName
              ? `${defaultContentClass} ${contentClassName}`.trim()
              : defaultContentClass
          }
          style={{
            ...defaultContentStyle,
            ...contentStyle,
            padding: "16px",
          }}
        >
          {children}
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
